import axios from '../utils/axios';

export default function changeSeekerActivationStatus(adminId, data){
    return axios.post(`/admin/${adminId}/jobseeker-admin/v2/admin-recruiter/change-activation-status`, data);
}